import { UseFormReturn } from "react-hook-form";
import { useEffect } from "react";
import { AvailabilityPreferences } from "./types";
import { getRelateServicesFromConstants } from "../../../utils/getRelatedServicesFromConstants";

/**
 * Custom hook to manage form logic for availability preferences.
 * @param entityForm - The form instance from react-hook-form.
 * @returns An object containing the watched form values and derived states.
 */
export const useAvailabilityFormLogic = (entityForm: UseFormReturn<AvailabilityPreferences>) => {
    const selectedServiceFirst = entityForm.watch("firstService");
    const selectedServiceSecond = entityForm.watch("secondService");
    const treatmentSelected = entityForm.watch("treatment");
    const psychologistTreatment = treatmentSelected?.theurapists_involved_in_treamtent?.slice(-1)[0]?.technicians_id;
    const clientOwnerTreatment = treatmentSelected?.client_owner;
    const requireConsecutiveSessions = entityForm.watch("requireConsecutiveSessions");
    const ageGroupsSelected = entityForm.watch("age_groups");
    const disorderSpecializationSelected = entityForm.watch("disorder_specialization");
    const psyRelated = getRelateServicesFromConstants("psy");
    const reportsRelated = getRelateServicesFromConstants("reports");
    const firstServiceIsPsy = selectedServiceFirst && psyRelated.includes(selectedServiceFirst.id);
    const firstServiceIsReports = selectedServiceFirst && reportsRelated.includes(selectedServiceFirst.id);
    const secondServiceIsPsy = selectedServiceSecond && psyRelated.includes(selectedServiceSecond.id);
    const secondServiceIsReports = selectedServiceSecond && reportsRelated.includes(selectedServiceSecond.id);

    useEffect(() => {
        if (!requireConsecutiveSessions) {
            entityForm.setValue("secondService", undefined);
        }

        if (selectedServiceFirst && firstServiceIsPsy) {
            entityForm.setValue("firstServiceTechnician", psychologistTreatment);
        }

        if (selectedServiceSecond && secondServiceIsPsy) {
            entityForm.setValue("secondServiceTechnician", psychologistTreatment);
        }

        if (selectedServiceFirst && firstServiceIsReports) {
            entityForm.setValue("firstServiceTechnician", clientOwnerTreatment);
        }

        if (selectedServiceSecond && secondServiceIsReports) {
            entityForm.setValue("secondServiceTechnician", clientOwnerTreatment);
        }

        if (!firstServiceIsPsy && !firstServiceIsReports) {
            entityForm.setValue("firstServiceTechnician", undefined);
        }

        if (!secondServiceIsPsy && !secondServiceIsReports) {
            entityForm.setValue("secondServiceTechnician", undefined);
        }
    }, [
        treatmentSelected,
        selectedServiceFirst?.id,
        selectedServiceSecond?.id,
        requireConsecutiveSessions,
        firstServiceIsPsy,
        firstServiceIsReports,
        secondServiceIsPsy,
        secondServiceIsReports,
    ]);

    const formLogicData = {
        selectedServiceFirst,
        selectedServiceSecond,
        treatmentSelected,
        psychologistTreatment,
        clientOwnerTreatment,
        requireConsecutiveSessions,
        ageGroupsSelected,
        disorderSpecializationSelected,
        firstServiceIsPsy,
        firstServiceIsReports,
        secondServiceIsPsy,
        secondServiceIsReports
    };

    return formLogicData;
}; 